import { render } from "./SettingsBarBtn.vue?vue&type=template&id=1d2f21f6&scoped=true"
import script from "./SettingsBarBtn.vue?vue&type=script&lang=js"
export * from "./SettingsBarBtn.vue?vue&type=script&lang=js"

import "./SettingsBarBtn.vue?vue&type=style&index=0&id=1d2f21f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2f21f6"]])

export default __exports__